module.exports = __webpack_public_path__ + "img/icon_3.32bb4d74.png";